import { useGetUser } from "atom/user";
import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const useCheckCompany = () => {
    const navigate = useNavigate();
    const user = useGetUser();
    const hasCheckedRef = useRef<boolean>(false);

    useEffect(() => {
        if (user.id && !hasCheckedRef.current) {
            hasCheckedRef.current = true;
            if (!user?.companyInfo?.companyFileInfo.fileName) {
                toast.error('사업자등록증 정보가 없습니다.')
                navigate('/')
                return
            }
        }
    }, [user.id]);
};

export default useCheckCompany